import { render, staticRenderFns } from "./Keycap.vue?vue&type=template&id=d8961286&scoped=true&"
import script from "./Keycap.vue?vue&type=script&lang=js&"
export * from "./Keycap.vue?vue&type=script&lang=js&"
import style0 from "./Keycap.vue?vue&type=style&index=0&id=d8961286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8961286",
  null
  
)

export default component.exports